<template>
    <div>
        <header class="mb-5">
            <div class="round-64 relative dinlineb valign-middle primary-50-bkg"><i class="fab fa-sellsy absolute-center white" style="font-size:32px;"></i></div>
            <div class="dinlineb valign-middle ml-3">
                <h2 class="m-0 mb-2">{{ $l10n.__('Rapprochement bancaire') }}</h2>
                <a href="/?_f=bankreconciliation_transactions" class="semibold flex-level">
                    <i class="icon-arrow-back mr-1"></i>
                    <span>{{ $l10n.__("Retour") }}</span>
                </a>
            </div>
        </header>
        <div class="step-container m-auto">
            <!-- <keep-alive> -->
                <router-view 
                    :idImport="idImport"
                    :csv="csv"
                    v-model="form"
                    :nextStep="nextStep"
                    :previousStep="previousStep"
                    @update-csv="updateCSV"
                    @update-import-id="updateIdImport"
                    @next="goToNextStep"
                    @previous="goToPreviousStep"
                />
            <!-- </keep-alive> -->
        </div>
    </div>
</template>

<script>

    export default {
        props: [],
        data(){
            return {
                csv: [],
                idImport: 0,
                form: {
                    config: {
                        offset: null,
                    },
                    template: {
                        date: {
                            columns: [],
                            arguments: {
                                format: 'dmY'
                            }
                        },
                        label: {
                            columns: [],
                            arguments: {
                                glue: ','
                            }
                        },
                        amount_with_type: {
                            columns: []
                        },

                        amount_debit: {
                            columns: [],
                        },
                        amount_credit: {
                            columns: [],
                        },

                        amount: {
                            columns: []
                        },
                        type_from_string: {
                            columns: [],
                            arguments: {
                                debit: '',
                                credit: ''
                            }
                        },
                        amountType: '1col',
                    },
                }
            }
        },
        computed: {
            currentStepMeta(){
                return this.$route.meta
            },
            nextStep(){
                return this.currentStepMeta.next ? this.currentStepMeta.next : false
            },
            previousStep(){
                return this.currentStepMeta.previous ? this.currentStepMeta.previous : false
            }
        },
        methods: {
            goToNextStep(forceRoute){
                if(forceRoute && forceRoute != ''){
                    this.$router.push({name: forceRoute, params: {importid: this.idImport}})
                } else{
                    this.$router.push({name: this.currentStepMeta.next, params: {importid: this.idImport}})
                }
            },
            goToPreviousStep(){
                this.$router.push({name: this.currentStepMeta.previous})
            },
            updateCSV(csv){
                this.csv = csv
            },
            updateIdImport(id){
                this.idImport = id
            }
        }
    }
</script>

<style scoped lang="scss">
.step-container{
    width: 720px;
    .step-container-table{
        overflow: scroll;
        max-height: 300px;
    }
}
</style>
